import { useEffect } from 'react';
import { SiteActions } from '@/redux/site/actions';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@/store';
import {
  Introduction,
  Stats,
  Participate,
  Onboarding,
  Slider,
  Team,
  Future,
  Refer,
  NextGenGaming,
  PrometheusChestplate,
} from '@/modules/token-sale';
import { Footer } from '@/components/Footer';
import { ScrollDown } from '@/components/ScrollDown';

export default function Infrastrucuture() {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(SiteActions.loadSite());
  }, []);

  return (
    <div className="token-sale">
      <Introduction />
      <Stats />
      {/*
      <Participate />
      */}
      <Onboarding />
      <NextGenGaming />
      <Future />
      <PrometheusChestplate />
      <Slider />
      <Team />
      <Refer />

      <Footer />

      <ScrollDown anchor="token-sale-stats" />
    </div>
  );
}
